/* eslint-disable object-curly-newline */
import getDefaultState from './get-default-state';
import providerStates from '../provider'
// import { forEach } from "@/utils/lodash";

export default {
  setProducts(state, { products, filters}) {
    state.products = products;
    if(filters && filters.providerId) {
      if(providerStates.state.providers.results){
        providerStates.state.providers.results = providerStates.state.providers.results.map((m) => {
          if(m.id == filters.providerId){
            return {
              productList : products.results,
              ...m,
            }
          }
          return {
            ...m,
          }
        })
      }
    }
  },
  setDownloadPDF(state, payload) {
    if (payload) {
      const url = window.URL.createObjectURL(new Blob([payload], { type: 'application/pdf' }));
      return url;
    }    
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  },

  setFilters(state, { attributes, productTypes, countries, regions }) {
    state.filters = { attributes, productTypes, countries, regions };
  },

  setProduct(state, product) {
    state.product = product;
  },
  setCarouselProducts(state, carousel) {
    state.carousel = carousel;
  },
  setProductInv(state, product) {
    state.productInv = product;
  }
};
